<template>
    <transition>
        <section class="tablet-portrait-alert" v-if="show">
            <div class="bg"></div>
            <div class="content">
                <img :src="urlImg">
                <p>Pour une meilleure expérience, nous vous conseillons de tourner votre tablette en paysage</p>
                <button class="btn chevron" @click.prevent="closeAlert()">J'ai compris</button>
            </div>
        </section>
    </transition>
</template>

<script>
    import {DateTime, Interval} from 'luxon';

    export default {
        props: {
            urlImg: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                show: true,
                dt_now: DateTime.local()
            };
        },
        computed: {},
        methods: {
            closeAlert() {
                localStorage.setItem('GE_Portrait_Alert', true);
                localStorage.setItem('GE_Portrait_Alert_Valid_Date', this.dt_now.toISO());
                this.show = false;
            }
        },
        created() {

            if (localStorage.GE_Portrait_Alert) {
                let lastCheck = DateTime.fromISO(localStorage.GE_Portrait_Alert_Valid_Date);
                let i = Interval.fromDateTimes(lastCheck, this.dt_now).toDuration('days').toObject();

                if (i > 2) {
                    // Au dela de 1 jour, on recheck
                    this.show = true;
                } else {
                    this.show = !localStorage.GE_Portrait_Alert;
                }

            }
        }
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/TabletPortraitAlert.vue